<template>
     <div class="w_inner">
          <div class="main_container">

                <div class="mabout_content culture">
                     <div class="cultureShow" v-if="currentLang=='zh'">
                              <img :src="CompanyInfo.aboutTopMobileImg" alt="">
                     </div>
                     <div class="cultureShow" v-else>
                              <img :src="CompanyInfo.aboutTopMobileImgEn" alt="">
                     </div>
                </div>

                <div class="mabout_content culture">
                    <div class="cultureShow" v-if="currentLang=='zh'">
                              <img :src="CompanyInfo.historyMobileImg" alt="">
                     </div>
                     <div class="cultureShow" v-else>
                              <img :src="CompanyInfo.historyMobileImgEn" alt="">
                     </div>
                </div>
               
                <div class="mabout_content layout">
                     <div class="layoutShow">
                          <div class="title">{{$t('about.layout')}}</div>
                          <div class="list">
                                   <div class="swiper-container">
                                        <div class="swiper-wrapper">
                                             <div class="swiper-slide item" v-for="(item, index) in layoutList" :key="index">
                                                  <div class="img">
                                                       <img v-if="currentLang=='zh'" :src="item.img">
                                                       <img v-else :src="item.enimg">
                                                  </div>
                                                  <div v-if="currentLang=='zh'" class="tishow">{{ item.title }}</div>
                                                  <div v-else class="tishow">{{ item.entitle }}</div>
                                             </div>
                                        </div>
                                        <div class="swiper-pagination"></div>
                                   </div>
                              </div>
                     </div>
                </div>
               <div class="mabout_content culture">
                    <div class="cultureShow" v-if="currentLang=='zh'">
                              <img :src="CompanyInfo.coreCompetenceMobileImg" alt="">
                     </div>
                     <div class="cultureShow" v-else>
                              <img :src="CompanyInfo.coreCompetenceMobileImgEn" alt="">
                     </div>
                </div>
                <div class="mabout_content research">
                     <div class="researchShow">
                              <div class="title">{{$t('about.introduction')}}</div>
                              <div class="swiper-container1">
                                   <div class="swiper-wrapper">
                                        <div class="swiper-slide item" v-for="(item, index1) in resarchList" :key="index1">
                                             <img :src="item">
                                        </div>
                                   </div>
                                   <div class="swiper-pagination1"></div>
                              </div>
                         </div>
                </div>

          </div>
     </div>

</template>

<script>
import { mapState } from 'vuex'
import Swiper from 'swiper'
import 'swiper/css/swiper.min.css'
export default {
     data() {
          return {
               layoutList: [],
               resarchList: [],
               // imgList: [],
               currentLang:this.$i18n.locale
          }
     },
     computed: {
          ...mapState({
               CompanyInfo: state => state.CompanyInfo
          })
     },
     created: function () {
          
     },

     methods: {
          HandleInfo() {
               if (this.CompanyInfo.researchMbileList) {
                    this.layoutList = JSON.parse(this.CompanyInfo.researchMbileList);
               } else {               
                    this.layoutList = [];
               }
               this.resarchList = this.currentLang=='zh'? this.CompanyInfo.researchMobileImg.split(','):this.CompanyInfo.researchMobileImgEn.split(',');
               this.InitSwiper();
               this.InitSwiper1();
          },
          InitSwiper() {
          
               var _this = this;
               this.$nextTick(() => {
                    this.swiper = new Swiper(".swiper-container", {
                         loop: false,
                         slidesPerView: 1,
                         slidesPerGroup: 1,
                         speed: 2000,
                         autoplay: true,
                         pagination: {
                              el: ".swiper-pagination",
                              clickable: true,
                         },
                         on: {
                              click: function (event) {
                                   var t = event.target;
                                   if (t && t.getAttribute("index")) {
                                        var _imgViewerIndex = parseInt(t.getAttribute("index"));
                                        // console.log(_imgViewerIndex);
                                        _this.$viewerApi({
                                             options: {
                                                  toolbar: true,
                                                  title: false,
                                                  initialViewIndex: _imgViewerIndex
                                             },
                                             images: _this.imgList,
                                        })
                                   }
                              }
                         }
                    });
               });
          },
          InitSwiper1() {
               var _this = this;
               this.$nextTick(() => {
                    this.swiper = new Swiper(".swiper-container1", {
                         loop: true,
                         slidesPerView: 1,
                         slidesPerGroup: 1,
                         speed: 600,
                         autoplay: {
                              delay: 4000,
                              disableOnInteraction: false,
                         },
                         pagination: {
                              el: ".swiper-pagination1",
                              clickable: true,
                         },
                    });
               });
          },
     },
     watch: {
         CompanyInfo() {
               this.HandleInfo();
          }
     }
};
</script>
